import React from 'react';

export default function StatBar({ icon, label, value }) {
  const rounded = Math.round(value);
  return (
    <div className="stat-row">
      <div className="stat-topline">
        <span className="stat-label"><span>{icon}</span>{label}</span>
        <span className="stat-value">{rounded}%</span>
      </div>
      <div className="stat-track">
        <div className={`stat-fill ${rounded < 25 ? 'critical' : rounded < 55 ? 'warning' : ''}`} style={{ width: `${rounded}%` }} />
      </div>
    </div>
  );
}
